export default __webpack_public_path__ + "static/media/canchaPadel1.ce7b09ea.jpg";